import React, { useMemo } from "react";
import ProjectHelpWidget from "../../shared/widgets/ProjectHelpWidget";
import useSuggestionsIndex from "../../shared/hooks/useSuggestionsIndex";
import { STEP_PAGE_TYPE_MAP } from "../../../constants/suggestOptions";

const UserSuggestionsWidget = ({ step, anchorRef }) => {
  // step(=activeStep) から page_type を引く
  const pageType = STEP_PAGE_TYPE_MAP[step] ?? "";

  /**
   * user用：閲覧専用でサジェストを取得
   */
  const pageTypes = useMemo(() => {
    return pageType ? [pageType] : [];
  }, [pageType]);

  const base = useSuggestionsIndex({
    mode: "user",
    pageTypes,
  });

  // 表示用に content を整形
  const helpContents = useMemo(() => {
    if (!pageType) return [];
    return (base.suggestions ?? [])
      .filter((item) => item.content?.trim())
      .map((item) => item.content);
  }, [base.suggestions, pageType]);

  // ProjectHelpWidget が期待する formState 形式に合わせる
  const formState = useMemo(
    () => ({
      page_type: { contents: helpContents },
      isSuggestionsLoading: base.isSuggestionsLoading,
    }),
    [helpContents, base.isSuggestionsLoading],
  );

  // プロジェクト情報（サジェスト無し）は何も表示しない
  if (!pageType) return null;

  return (
    <ProjectHelpWidget
      mode="user"
      step={step}
      anchorRef={anchorRef}
      formState={formState}
    />
  );
};

export default UserSuggestionsWidget;
